import React, { useState, useEffect, useRef } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import CustomDialog from "../common/tableComponent.js/dialog";
import { initiateRequest } from "../common/customServiceCall/serviceCall";
import { useSelector } from "react-redux";
import { Calendar } from "primereact/calendar";
import { InputText } from "primereact/inputtext";
import { ProgressSpinner } from "primereact/progressspinner";
import { format } from "date-fns";
import { Dropdown } from "primereact/dropdown";
import { Toast } from "primereact/toast";

const Configuration = () => {
  const toast = useRef(null);

  const [loading, setLoading] = useState(false);
  const [config, setConfig] = useState([]);
  const [showEditModal, setShowEditModal] = useState(false);
  const [showAddModal, setShowAddModal] = useState(false);
  const [showViewModal, setShowViewModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [datetime24h, setDateTime24h] = useState(null);
  const [name, setName] = useState("");
  const [selectedConfigData, setSelectedConfigData] = useState(null);
  const [modalName, setModalName] = useState("");
  const [apiMethod, setApiMethod] = useState("");
  const [selectedConfig, setSelectedConfig] = useState();

  // Add modal
  const [formData, setFormData] = useState({
    name: "",
    type: "",
    response: "",
    format: "",
    code: "",
    systemCode: "",
    header: "",
    institutionId: "",
    createdAt:"",
     modifiedAt:""
  });


  const mockData = [{
    id:"fhasfhnsfs",
    name:"config",
    default:"true",
    type:"KYC",
    response:"test",
    format:"JSON",
    code:"01",
    systemCode:"02",
    header:"header",
    institutionId:"mockData12",
    createdAt:"22-05-2024",
     modifiedAt:"23-05-2024"
  },
  {
    id:"123GHQW",
    name:"config1",
    default:"false",
    type:"DEPOSIT",
    response:"test",
    format:"XML",
    code:"02",
    systemCode:"01",
    header:"header",
    institutionId:"mockData10",
    createdAt:"22-05-2024",
     modifiedAt:"23-05-2024"
  },
]

  const handleEditModalDisplay = (rowData) => {
    setModalName("Update Configuration");
    setSelectedConfigData(rowData);
    setApiMethod("put");
    console.log(rowData);
    setFormData({
      name: rowData.name || "N/A",
      type: rowData.type || "N/A",
      response: rowData.response || "N/A",
      format: rowData.format || "N/A",
      code: rowData.code || "N/A",
      systemCode: rowData.systemCode || "N/A",
      header: rowData.header || "N/A",
      institutionId: rowData.institutionId || "N/A",
    });
    setShowAddModal(true);
  };

  const handleAddModalDisplay = () => {
    setApiMethod("post");
    setModalName("Add Configuration");
    setFormData({
      name: "",
      type: "",
      response: "",
      format: "",
      code: "",
      systemCode: "",
      header: "",
      institutionId: "",
    });
    setShowAddModal(!showAddModal);
  };

  const handleViewModalDisplay = async (rowData) => {
    setSelectedConfigData(rowData); // Set the selected provider data
    setShowViewModal(true); // Open the modal
  };

  const handleDeleteModal = async (rowDataId) => {
    setShowDeleteModal(true);
    setSelectedConfig(rowDataId);

  };

  const actions = (rowData) => (
    <>
      <Button
        label=""
        icon="pi pi-pencil"
        className="p-button-info p-mr-2"
        onClick={() => handleEditModalDisplay(rowData)}
        style={{ fontSize: "15px", padding: "7px" }}
        data-tip="Take Action"
        data-for="toolTip1"
        data-place="top"
      />
      <Button
        label=""
        icon="pi pi-eye"
        className="p-button-success p-mr-2"
        onClick={() => handleViewModalDisplay(rowData)}
        style={{ fontSize: "15px", padding: "7px" }}
        data-tip="View Details"
        data-for="toolTip1"
        data-place="top"
      />
      <Button
        label=""
        icon="pi pi-trash"
        className="p-button-success p-mr-2"
        onClick={() => handleDeleteModal(rowData.id)}
        style={{ fontSize: "15px", padding: "7px" }}
        data-tip="View Details"
        data-for="toolTip1"
        data-place="top"
      />
    </>
  );

  const userDetails = useSelector((state) => state.login.userDetails);
  console.log("data", userDetails);

  const fetchData = async () => {
    setLoading(true); // Start loading
    const requestData = {
      created_at: datetime24h ? datetime24h.toISOString() : "",
      name: name || "", // Update with state
      size: "9999999",
    };

    // const queryString = new URLSearchParams(requestData).toString();
    try {
      const response = await initiateRequest("get", `/mapres/api/v1/responsemapper`);
      if (response.code === "00") {
        const fetchedData = response.data;
        setConfig(fetchedData);
      } else {
        console.error("Failed to fetch data:", response.message);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false); // Stop loading
    }
  };

  const handleDeleteData = async (rowDataId) => {
    setLoading(true); // Start loading
    try {
      const response = await initiateRequest(
        "delete",
        `/responsemapper/id/${rowDataId}`
      );
      if (response.code === "00") {
        setShowAddModal(false); // Close the modal
        fetchData(); // Refresh the table data
        toast.current.show({
          severity: "success",
          summary: "Success",
          detail: response.message,
          life: 3000, // Duration of the toast in milliseconds
        });
      } else {
        console.error("Failed to fetch data:", response.message);
        toast.current.show({
          severity: "error",
          summary: "Error",
          detail: response.message,
          life: 3000,
        });
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false); // Stop loading
    }
  };

  useEffect(() => {
    fetchData();
  }, [datetime24h, name]); // Re-fetch data when filters change

  const getSearchedData = () => {
    fetchData(); // Re-fetch the data with the updated filters
  };

  const formatCreatedOn = (rowData) => {
    return rowData.createdOn
      ? format(new Date(rowData.createdOn), "yyyy-MM-dd HH:mm:ss")
      : "";
  };

  const cardStyle = { borderRadius: "40px" };

  const labelStyleLeft = { fontSize: "14px" };

  const labelStyleRight = {
    fontSize: "14px",
    float: "left",
    fontWeight: "500",
  };

  const handleAddSubmit = async () => {
    try {
      setLoading(true); // Start loading
      const response = await initiateRequest(
        apiMethod,
        "/mapres/api/v1/responsemapper",
        formData
      );
      if (response.code === "00") {
        // Successfully added provider
        setShowAddModal(false); // Close the modal
        fetchData(); // Refresh the table data
        toast.current.show({
          severity: "success",
          summary: "Success",
          detail: response.message,
          life: 3000, // Duration of the toast in milliseconds
        });
      } else {
        console.error("Failed to add provider:", response.message);
        toast.current.show({
          severity: "error",
          summary: "Error",
          detail: response.message,
          life: 3000,
        });
      }
    } catch (error) {
      console.error("Error adding provider:", error);
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail: "Error adding provider",
        life: 3000,
      });
    } finally {
      setLoading(false); // Stop loading
    }
  };



  const formatOptions = [
    { label: "JSON", value: "JSON" },
    { label: "XML", value: "XML" },
    { label: "STRING", value: "STRING" },
  ];

  const typeOptions = [
    { label: "DEPOSIT", value: "DEPOSIT" },
    { label: "KYC", value: "KYC" },
    { label: "STATUS", value: "STATUS" },
  ];

  return (
    <section className="p-my-4 p-md-12 p-xl-12" style={{ padding: "0px 10%" }}>
      <Toast ref={toast} />

      <div className="p-grid p-fluid">
        <div
          className="p-col-12 p-sm-12 p-md-10 p-lg-10 p-xl-10 p-md-offset-1 p-lg-offset-1 p-xl-offset-1"
          style={{ textAlign: "center" }}
        >
          <span className="p-tag custom-heading">Configurations</span>
        </div>
      </div>

      <div className="card">
        <div
          className="p-col-12 "
          style={{ paddingTop: "5px", paddingBottom: "5px" }}
        >
          <div
            className="p-grid p-justify-between p-fluid"
            style={{
              marginTop: "24px",
            }}
          >
            <div className="p-field p-col-6 p-md-3">
              <span className="p-float-label">
                <Calendar
                  id="calendar-24h"
                  value={datetime24h}
                  onChange={(e) => {
                    setDateTime24h(e.value);
                    fetchData(); // Fetch data when date is selected
                  }}
                  showTime
                  hourFormat="24"
                  placeholder="Date Created At"
                />

                {/* <label style={floatLabel}>DATE </label> */}
              </span>
            </div>

            <div className="p-col-12 p-md-4 p-xl-4">
              <div className="p-grid">
                <div className="" style={{ paddingLeft: "0.4px" }}>
                  <div className="p-inputgroup">
                    <InputText
                      value={name}
                      onChange={(e) => setName(e.target.value)}
                      placeholder="Enter Name"
                    />
                    <Button
                      onClick={getSearchedData}
                      icon="pi pi-search"
                      className="p-button-info"
                    />
                    <Button
                      icon="pi pi-plus"
                      onClick={handleAddModalDisplay}
                      className="p-button-info"
                      style={{ fontSize: "15px", marginLeft: "10px" }}
                      data-tip="Add User"
                      data-for="toolTip1"
                      data-place="top"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="card">
        {loading ? (
          <div style={{ textAlign: "center", padding: "20px" }}>
            <ProgressSpinner />
          </div>
        ) : (
          <DataTable
            value={mockData}
            paginator
            rows={5}
            rowsPerPageOptions={[5, 10, 25, 50]}
            tableStyle={{ width: "100%" }}
          >
            <Column
              field="id"
              header="id"
              style={{ width: "100%" }}
            ></Column>
            <Column
              field="name"
              header="name"
              style={{ width: "100%" }}
            ></Column>
            <Column
              field="default"
              header="Default"
              style={{ width: "100%" }}
            ></Column>
            <Column
              field="type"
              header="Type"
              style={{ width: "100%" }}
            ></Column>
            <Column
              field="response"
              header="Response"
              style={{ width: "100%" }}
            ></Column>
            <Column
              field="format"
              header="Format"
              style={{ width: "100%" }}
            ></Column>
            <Column
              field="code"
              header="Code"
              style={{ width: "100%" }}
            ></Column>

            <Column
              header="Actions"
              style={{ width: "200px" }}
              body={actions}
            ></Column>
          </DataTable>
        )}
      </div>
      <>
        <CustomDialog
          visible={showViewModal}
          header="View Provider Modal"
          onClose={() => setShowViewModal(false)}
        >
          {selectedConfigData && (
            <div
              className="p-grid p-fluid transaction"
              style={{ height: "70vh", overflowY: "scroll" }}
            >
              <div className="p-col-12 p-sm-12 p-md-12 p-lg-12 p-xl-12">
                <div style={cardStyle}>
                  <div className="p-grid">
                    <div className="p-col-6 p-md-6 p-lg-6 p-xl-6 profileTop">
                      <label style={labelStyleLeft}>Id</label>
                    </div>
                    <div className="p-col-6 p-md-6 p-lg-6 p-xl-6 profileTop">
                      <label style={labelStyleRight}>
                        {selectedConfigData.id}
                      </label>
                    </div>
                  </div>
                  <div className="p-grid">
                    <div className="p-col-6 p-md-6 p-lg-6 p-xl-6 profileTop">
                      <label style={labelStyleLeft}>Name</label>
                    </div>
                    <div className="p-col-6 p-md-6 p-lg-6 p-xl-6 profileTop">
                      <label style={labelStyleRight}>
                        {selectedConfigData.name}
                      </label>
                    </div>
                  </div>
                  <div className="p-grid">
                    <div className="p-col-6 p-md-6 p-lg-6 p-xl-6 profileTop">
                      <label style={labelStyleLeft}>Default</label>
                    </div>
                    <div className="p-col-6 p-md-6 p-lg-6 p-xl-6 profileTop">
                      <label style={labelStyleRight}>
                        {selectedConfigData.default}
                      </label>
                    </div>
                  </div>
                  <div className="p-grid">
                    <div className="p-col-6 p-md-6 p-lg-6 p-xl-6 profileTop">
                      <label style={labelStyleLeft}>Type</label>
                    </div>
                    <div className="p-col-6 p-md-6 p-lg-6 p-xl-6 profileTop">
                      <label style={labelStyleRight}>
                        {selectedConfigData.type}
                      </label>
                    </div>
                  </div>
                  <div className="p-grid">
                    <div className="p-col-6 p-md-6 p-lg-6 p-xl-6 profileTop">
                      <label style={labelStyleLeft}>
                        Response
                      </label>
                    </div>
                    <div className="p-col-6 p-md-6 p-lg-6 p-xl-6 profileTop">
                      <label style={labelStyleRight}>
                        {selectedConfigData.response}
                      </label>
                    </div>
                  </div>
                  <div className="p-grid">
                    <div className="p-col-6 p-md-6 p-lg-6 p-xl-6 profileTop">
                      <label style={labelStyleLeft}>Format</label>
                    </div>
                    <div className="p-col-6 p-md-6 p-lg-6 p-xl-6 profileTop">
                      <label style={labelStyleRight}>
                        {selectedConfigData.format}
                      </label>
                    </div>
                  </div>
                  <div className="p-grid">
                    <div className="p-col-6 p-md-6 p-lg-6 p-xl-6 profileTop">
                      <label style={labelStyleLeft}>Header</label>
                    </div>
                    <div className="p-col-6 p-md-6 p-lg-6 p-xl-6 profileTop">
                      <label style={labelStyleRight}>
                        {selectedConfigData.header}
                      </label>
                    </div>
                  </div>

                  <div className="p-grid">
                    <div className="p-col-6 p-md-6 p-lg-6 p-xl-6 profileTop">
                      <label style={labelStyleLeft}>Code</label>
                    </div>
                    <div className="p-col-6 p-md-6 p-lg-6 p-xl-6 profileTop">
                      <label style={labelStyleRight}>
                        {selectedConfigData.code}
                      </label>
                    </div>
                  </div>
                  <div className="p-grid">
                    <div className="p-col-6 p-md-6 p-lg-6 p-xl-6 profileTop">
                      <label style={labelStyleLeft}>System code</label>
                    </div>
                    <div className="p-col-6 p-md-6 p-lg-6 p-xl-6 profileTop">
                      <label style={labelStyleRight}>
                        {selectedConfigData.systemCode}
                      </label>
                    </div>
                  </div>
                  <div className="p-grid">
                    <div className="p-col-6 p-md-6 p-lg-6 p-xl-6 profileTop">
                      <label style={labelStyleLeft}>Institution Id</label>
                    </div>
                    <div className="p-col-6 p-md-6 p-lg-6 p-xl-6 profileTop">
                      <label style={labelStyleRight}>
                        {selectedConfigData.institutionId}
                      </label>
                    </div>
                  </div>
                  <div className="p-grid">
                    <div className="p-col-6 p-md-6 p-lg-6 p-xl-6 profileTop">
                      <label style={labelStyleLeft}>Created At</label>
                    </div>
                    <div className="p-col-6 p-md-6 p-lg-6 p-xl-6 profileTop">
                      <label style={labelStyleRight}>
                        {selectedConfigData.createdAt}
                      </label>
                    </div>
                  </div>
                  <div className="p-grid">
                    <div className="p-col-6 p-md-6 p-lg-6 p-xl-6 profileTop">
                      <label style={labelStyleLeft}>Modified At</label>
                    </div>
                    <div className="p-col-6 p-md-6 p-lg-6 p-xl-6 profileTop">
                      <label style={labelStyleRight}>
                        {selectedConfigData.modifiedAt}
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </CustomDialog>
        <CustomDialog
          visible={showAddModal}
          header={modalName}
          onClose={() => setShowAddModal(false)}
        >
          <div
            className="p-grid p-fluid"
            style={{ height: "70vh", overflowY: "scroll" }}
          >
            <div className="p-col-12">
              <div className="p-field">
                <label htmlFor="name">Name</label>
                <InputText
                  id="name"
                  value={formData.name}
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      name: e.target.value,
                    })
                  }
                  placeholder="name"
                />
              </div>
            </div>
            
            <div className="p-col-12">
              <div className="p-field">
                <label htmlFor="type">Type</label>
                <Dropdown
                  value={formData.type}
                  onChange={
                    (e) => setFormData({ ...formData, type: e.value }) // e.value will contain the 'value' of the selected option
                  }
                  options={typeOptions}
                  optionLabel="label"
                  placeholder="Select interface"
                  className="w-full md:w-14rem"
                />
              </div>
            </div>
            <div className="p-col-12">
              <div className="p-field">
                <label htmlFor="format">Format</label>
                <Dropdown
                  value={formData.format}
                  onChange={
                    (e) => setFormData({ ...formData, format: e.value }) // e.value will contain the 'value' of the selected option
                  }
                  options={formatOptions}
                  optionLabel="label"
                  placeholder="Select interface"
                  className="w-full md:w-14rem"
                />
              </div>
            </div>
            <div className="p-col-12">
              <div className="p-field">
                <label htmlFor="response">Response</label>
                <InputText
                  id="response"
                  value={formData.response}
                  onChange={(e) =>
                    setFormData({ ...formData, reesponse: e.target.value })
                  }
                  placeholder="response"
                />
              </div>
            </div>
            <div className="p-col-12">
              <div className="p-field">
                <label htmlFor="code">Code</label>
                <InputText
                  id="code"
                  value={formData.code}
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      codee: e.target.value,
                    })
                  }
                  placeholder="code"
                />
              </div>
            </div>
            <div className="p-col-12">
              <div className="p-field">
                <label htmlFor="systemCode">System Code</label>
                <InputText
                  id="systemCode"
                  value={formData.approved_by}
                  onChange={(e) =>
                    setFormData({ ...formData, systemCode: e.target.value })
                  }
                  placeholder="system code"
                />
              </div>
            </div>
            <div className="p-col-12">
              <div className="p-field">
                <label htmlFor="header">Header</label>
                <InputText
                  id="header"
                  value={formData.header}
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      header: e.target.value,
                    })
                  }
                  placeholder="header"
                />
              </div>
            </div>
            <div className="p-col-12">
              <div className="p-field">
                <label htmlFor="institutionId">Institution ID</label>
                <InputText
                  id="institutionId"
                  value={formData.institutionId}
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      institutionId: e.target.value,
                    })
                  }
                  placeholder="header"
                />
              </div>
            </div>
          </div>

          <div className="p-grid">
            <div className="p-col-12 p-grid p-justify-end">
              <Button
                label="Submit"
                onClick={handleAddSubmit}
                className="p-button-info "
                style={{ marginTop: "10px" }}
              />
            </div>
          </div>
        </CustomDialog>
        <CustomDialog
          visible={showDeleteModal}
          header="Delete Configuration"
          onClose={() => setShowDeleteModal(false)}
        >
          Are you sure you want to delete <span style={{color:"green", fontWeight:"bold"}}>{selectedConfig}</span>
          <div className="p-col-12 p-grid p-mt-3 p-justify-end">
            <Button label="NO" onClick={() => setShowDeleteModal(false)} className="p-mx-2" />
            <Button
              label="YES"
              onClick={() => handleDeleteData(selectedConfig)}
            />
          </div>
        </CustomDialog>
      </>
    </section>
  );
};

export default Configuration;
